/**
 * External Imports
 */
import { FC, ReactChild, useRef } from 'react';
import { connect } from 'react-redux';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';

/**
 * Internal Imports
 */
import { RootState } from '../../../../redux/store';
import { handleModal } from '../../../../services/ModalPortal/utils';

/**
 * Style Imports
 */
import {
  Card,
  CardHeader,
  ModalTitle,
  TitleIcon,
  ModalCardContent,
  ModalFooter
} from './ModalCard.styles';

interface ModalCardProps {
  headerIcon: string;
  headerTitle: string;
  modalRightBtnText: string;
  modalLeftBtnText: string;
  children: ReactChild[] | ReactChild;
  isApplyFiltersDisabled?: boolean;
  modalLeftBtnAction: () => void;
  modalRightBtnAction: () => void;
}

const ModalCard: FC<ModalCardProps> = ({
  headerIcon,
  headerTitle,
  modalRightBtnText,
  modalLeftBtnText,
  children,
  isApplyFiltersDisabled,
  modalLeftBtnAction,
  modalRightBtnAction
}) => {
  const modalContentRef = useRef<HTMLNeuCardElement>(null);
  return (
    <Card
      id="Modal-Card"
      className="show-modal"
      unit="card"
      ref={modalContentRef}
    >
      <CardHeader unit="header">
        <ModalTitle>
          <TitleIcon size="3x" color="blue">
            {headerIcon}
          </TitleIcon>
          {headerTitle}
        </ModalTitle>
        <NeuButton
          id="Modal-Card-Close-Button"
          aria-label="close panel"
          icon="close"
          kind="tertiary"
          size="small"
          onClick={() => handleModal(modalContentRef)}
        >
          Close
        </NeuButton>
      </CardHeader>
      <ModalCardContent unit="content">{children}</ModalCardContent>
      <ModalFooter
        unit="footer"
        right={!(modalLeftBtnText && modalRightBtnText) ? true : undefined}
      >
        <NeuButton
          color="blue"
          kind="secondary"
          size="small"
          onClick={() => {
            // handleModal(modalContentRef);
            modalLeftBtnAction();
          }}
        >
          {modalLeftBtnText}
        </NeuButton>
        <NeuButton
          color="blue"
          size="small"
          onClick={() => {
            handleModal(modalContentRef);
            modalRightBtnAction();
          }}
          disabled={isApplyFiltersDisabled ?? false}
        >
          {modalRightBtnText}
        </NeuButton>
      </ModalFooter>
    </Card>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    modalState: state.ModalReducer.modal
  };
};
export default connect(mapReduxStateToProps)(ModalCard);
